import { toUtcShortDate, toShortDateAndTime } from '../utils/date-helpers';

const valueSelector = (rfi, key) => rfi[key] || '';
const createDateSelector = (dateFn) => (...args) => {
  const value = valueSelector(...args);
  if (value) {
    return `${dateFn(value)} (UTC)`;
  }
  return '';
};

const defaultSelector = (...args) => {
  const value = valueSelector(...args);
  const result = Array.isArray(value) ? value.join(', ') : value;
  return result.trim();
};
const shortDateSelector = createDateSelector(toUtcShortDate);
const dateWithTimeSelector = createDateSelector(toShortDateAndTime);

const rfisCsvMapping = [
  { key: 'customIdentifier', displayName: 'Id', selector: defaultSelector },
  { key: 'title', displayName: 'Title', selector: defaultSelector },
  { key: 'question', displayName: 'Question', selector: defaultSelector },
  { key: 'suggestedAnswer', displayName: 'Suggested answer', selector: defaultSelector },
  { key: 'locationDescription', displayName: 'Location details', selector: defaultSelector },
  { key: 'status', displayName: 'Status', selector: defaultSelector },
  { key: 'officialResponse', displayName: 'Response', selector: defaultSelector },
  { key: 'assignedToDisplayName', displayName: 'Assigned to', selector: defaultSelector },
  { key: 'assignedToType', displayName: 'Assignee type', selector: defaultSelector },
  { key: 'companyName', displayName: 'Company', selector: defaultSelector },
  { key: 'dueDate', displayName: 'Due date', selector: shortDateSelector },
  {
    key: 'targetUrn',
    displayName: 'Associated to document?',
    selector: (rfi, key) => (rfi[key] ? 'Yes' : 'No'),
  },
  { key: 'createdAt', displayName: 'Created at', selector: dateWithTimeSelector },
  {
    key: 'createdByDisplayNameWithCompanyName',
    displayName: 'Created by',
    selector: defaultSelector,
  },
  { key: 'updatedAt', displayName: 'Updated at', selector: dateWithTimeSelector },
  { key: 'updatedByDisplayName', displayName: 'Updated by', selector: defaultSelector },
  {
    key: 'distributionListDisplayNames',
    displayName: 'Distribution list',
    selector: defaultSelector,
  },
  { key: 'costImpact', displayName: 'Cost impact', selector: defaultSelector },
  { key: 'scheduleImpact', displayName: 'Schedule impact', selector: defaultSelector },
  { key: 'priority', displayName: 'Priority', selector: defaultSelector },
  { key: 'discipline', displayName: 'Discipline', selector: defaultSelector },
  { key: 'category', displayName: 'Category', selector: defaultSelector },
  { key: 'reference', displayName: 'Reference', selector: defaultSelector },
];
export default rfisCsvMapping;
